;(function ($, window) {
  'use strict'

  // setup a shared namespace, if needed
  window.GCO = window.GCO || {}

  window.GCO.animations = (function () {
    function init () {
      $('#links a').hover(
        function () { $(this).animate({ left: 3 }, 'fast') },
        function () { $(this).animate({ left: 0 }, 'fast') }
      )

      $('footer a').hover(
        function () { $(this).animate({ top: 3 }, 'fast') },
        function () { $(this).animate({ top: 0 }, 'fast') }
      )
    }

    return {
      init: init
    }
  }())

  $(document).ready(GCO.animations.init)
}(jQuery, window))
